import { Subscription } from 'rxjs';
import { UtilService } from 'src/app/services/util.service';
import { Paginate } from './../../../models/paginate.model';
import { LoginModalService } from '../../../services/auth/login-modal.service';
import { environment } from '../../../../environments/environment';
import { Response } from '../../../models/response.model';
import { BaseService } from '../../../services/base/base.service';
import { Component, Input, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { Article } from 'src/app/models/article.model';

@Component({
  selector: 'app-article-list',
  templateUrl: './article-list.component.html',
  styleUrls: ['./article-list.component.scss']
})
export class ArticleListComponent implements OnInit {
  @Input() isLastArticlePage: boolean = false;

  paginateConfig: {
    totalItems: number,
    itemsPerPage: number,
    currentPage: number
  } = {
      totalItems: 0,
      itemsPerPage: 6,
      currentPage: 1,
    }

  storageUrl = environment.BASE_STORAGE_URL;

  articles: Article[] = [];
  page: number = 1;
  totalPages: number = null;

  changeLog = [];
  filterBk: { keywords: string, other: {} };

  @Output() haveResultsEmitter: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() isFilteringEmitter: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  @Input() filter: { keywords: string, other: {} } = { keywords: null, other: null };
  @Input() nRegistros: number = 0;
  @Input() showPaginate: boolean = false;
  @Input() useApi: number = 1;

  articlesSubscription: Subscription;
  mostVisitedSubscription: Subscription;

  constructor(
    private baseService: BaseService,
    private loginModalService: LoginModalService,
    private utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.paginateConfig.totalItems = this.nRegistros;

    if (!this.filter.keywords && this.utilService.isEmptyObject(this.filter.other)) {
      this.getData(1);
    }
  }

  getData(page: number, filter: { keywords: string, other: {} } = { keywords: null, other: null }): void {

    this.articles = [];

    this.nRegistros = this.isLastArticlePage && page == 1 ? 7 : 6; //regra para pagina de ultimos artigos

    let filterData = { page: page, pageSize: this.nRegistros, _sortDirections: 'DESC', _sortFields: 'dtInclusao' };

    if (filter === null) {
      this.page = 1;
      this.isFilteringEmitter.emit(false);
    } else {
      for (let key in filter.other) {
        filterData[key] = filter.other[key];
      }
      this.isFilteringEmitter.emit(true);
    }

    if (this.articlesSubscription) {
      this.articlesSubscription.unsubscribe();
    }
    this.articlesSubscription = this.baseService
      .getAllNoHeader('v2/artigos', filterData, null)
      .subscribe((res: Response<Paginate<Article>>) => {
        if (res.retorno) {
          this.paginateConfig.currentPage = page;
          this.paginateConfig.totalItems = res.data.totalResults;

          if(this.isLastArticlePage && this.paginateConfig.currentPage === 1)res.data.list.shift();

          this.articles = res.data.list;
          this.haveResultsEmitter.emit(this.articles.length > 0 ? true : false);
        }
      })
  }

  openSignupModal(): void {
    this.loginModalService.openModalSignUp();
  }

  ngOnDestroy(): void {
    this.articlesSubscription.unsubscribe();
  }

}
